import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Home/Footer";
import MissionandVissionSlider1 from "../assets/img/OurVision&MissionPageSliderImage1.jpg";
import MissionandVissionSlider2 from "../assets/img/MissionVisson.jpg";

const bannerData = [
  {
    text: "Join us in shaping the future through collaboration!",
    img: MissionandVissionSlider1,
  },
  {
    text: "Innovate, Connect, and Transform with us.",
    img: MissionandVissionSlider2,
  },
];

const mandates = [
  "Capacity building of producers to enhance productivity and ensuring quality produce at farm level",
  "Facilitating timely availability of quality seeds and inputs",
  "Facilitating R&D transfer on field through improved variety and introduction of new seed varieties",
  "Promoting climate resilient and sustainable production practices",
  "Ensuring remunerative prices to producers through structured market linkages",
  "Innovative value addition and utilization of by-products into functional ingredients supporting circular economy",
  "Focus on scalable and economically feasible technologies for protein extraction to boost nutritional value and market potential",
  "Integrated Digital Platform",
  "Ensure smooth integration and convergence between Government initiatives and other value chain stakeholders",
  "Advancing Pulse Self-Sufficiency Aligned with National Mission",
];

const OurMandates = () => {
  const [bannerIndex, setBannerIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const interval = setInterval(() => {
      setBannerIndex((prev) => (prev + 1) % bannerData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      {/* Hero Section */}
      <div
        className="mandate-hero-section d-flex align-items-center justify-content-center text-center"
        style={{
          backgroundImage: `url(${bannerData[bannerIndex].img})`,
          height: "70vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
        data-aos="fade-in"
      >
        <div
          className="mandate-overlay"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
          }}
        ></div>
        <div className="mandate-header position-relative" data-aos="fade-up">
          <h1
            style={{ color: "#d4561a", fontSize: "3.5rem", fontWeight: "bold" }}
          >
            Our Mandates
          </h1>

          <p
            style={{
              color: "white",
              maxWidth: "700px",
              margin: "auto",
              fontSize: "1.2rem",
            }}
          >
            {bannerData[bannerIndex].text}
          </p>
        </div>
      </div>

      {/* Mandates Section */}
      <div className="mandate-container container py-5">
        <h2
          className="text-center "
          style={{ color: "#d4561a", fontWeight: "bold" }}
        >
          Our Mandates
        </h2>
        <div className="separator-line mb-5"></div>
        <div
          className="mandate-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "20px",
          }}
        >
          {mandates.map((mandate, index) => (
            <div
              key={index}
              data-aos="zoom-in"
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15px",
                  left: "-15px",
                  background: "#d4561a",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                }}
              >
                {index + 1}
              </div>
              <p
                style={{
                  marginTop: "10px",
                  color: "#333",
                  fontSize: "1rem",
                  lineHeight: "1.5",
                }}
              >
                {mandate}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OurMandates;
